import * as action_type from './../actions/userAuthentication/action_types';
const initialState = {
    status: 0,



}
const UserAuthentication = (state = initialState, action) => {
    switch (action.type) {
        case action_type.API_USERAUTH_SUCCESS:
            return Object.assign({}, state, {
                status: action.data
            });
        default:
            return state;
    }
}

export default UserAuthentication;


// WEBPACK FOOTER //
// ./src/redux/reducers/userAuth.js